import api from './api.service';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  username: string;
  expires_in: number;
}

export interface MeResponse {
  username: string;
}

export interface LockoutStatus {
  locked: boolean;
  remaining_seconds: number;
  max_attempts: number;
}

export const authService = {
  async login(username: string, password: string): Promise<LoginResponse> {
    const { data } = await api.post<LoginResponse>('/api/auth/login', {
      username,
      password,
    });
    return data;
  },

  async logout(): Promise<void> {
    await api.post('/api/auth/logout');
  },

  async me(): Promise<MeResponse> {
    const { data } = await api.get<MeResponse>('/api/auth/me');
    return data;
  },

  async lockoutStatus(): Promise<LockoutStatus> {
    const { data } = await api.get<LockoutStatus>('/api/auth/lockout-status');
    return data;
  },
};

export default authService;
